var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"octobus__price has-text-primary is-size-5-touch"},[(_vm.hasDiscount)?_c('p',{staticClass:"old-price has-text-dark has-text-weight-normal"},[_vm._v(_vm._s(_vm._f("currency")(_vm.price.withoutDiscount,_vm.currencySymbol)))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("currency")(_vm.price.total,_vm.currencySymbol)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b542ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Passenger/Price.vue
// module id = null
// module chunks = 